module.exports = __webpack_public_path__ + "img/m-banner-qdqhodgn-th-TH.de39dbda.png";